import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import * as PropTypes from 'prop-types'
import { Badge, ListGroup } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { Link, useParams } from 'react-router-dom'
import Order from 'state/models/Order'
import { Donkey, FMT, klass, useScheduledRefresh } from 'utils'

/**
 * @param order {Order}
 * @param noHighlight {boolean}
 * @param showStatus {boolean}
 */
export default function OrderRow({ order, noHighlight = false, showStatus = false }) {
	/** @type ?Restaurant */
	const restaurant = useSelector(order.getRestaurantIfNeedsDistinction)
	const { t }      = useTranslation()

	useScheduledRefresh(Donkey.ORDERS_INTERVAL,
		!noHighlight && //the time only shows when noHighlight==false...
		!order.is_due && //...due orders have fixed strings, but future orders at some point will stop being future...
		!Donkey.alreadyAskingAbout(Donkey.TOPIC.ORDERS))

	return (
		<ListGroup.Item as={Link} to={{ pathname: `/order/${order.id}`, state: { from: useParams().status } }}
		                {...klass({ [order.timeStatus.class]: !noHighlight, withMain: true, vipOrder: order.is_customer_vip })}>

			{restaurant && <aside className="secondary">
				<Badge pill style={{backgroundColor: restaurant.color, color: 'white'}}>{restaurant.display_name}</Badge>
			</aside>}

			<main>
				{order.is_customer_vip && <section className="d-none d-sm-block mr-sm-2">
					<FontAwesomeIcon size="lg" icon='star' />
				</section>}

				<section className={(order.is_customer_vip || order.is_considered_future) ? 'mr-sm-auto ml-sm-2' : ''}>
					{order.is_customer_vip && <section className="d-inline-flex mr-1 d-sm-none">
						<FontAwesomeIcon size="sm" icon='star' />
					</section>}
					{order.customer_name}&nbsp;

					{showStatus && order.statusSlug != Order.STATUS.ACTIVE &&
						<FontAwesomeIcon fixedWidth {...Order.ICONS[order.statusSlug]}
						                 {...klass({ textSuccess: order.is_completed, textDanger: order.is_cancelled })}/>
					}
					<p className="secondary text-bold-reset d-flex align-items-center">
						<order.type.Icon fixedWidth/>&nbsp;
						<order.comp.deliveryBadge t={t} defaultToOrderType/>&nbsp;
						<FontAwesomeIcon icon="chevron-right" size="sm"/>&nbsp;
						#{order.number}
					</p>
				</section>

				<section className="text-right">
					{order.readyAtFormatted(noHighlight)} {!noHighlight && <order.timeStatus.Icon fixedWidth/>}
					<div className="secondary">
						{noHighlight?
							<>{FMT.money(order.total_price)}</> :
							<><order.comp.dueTime/> {order.asap_no_time? null : <order.comp.isAsap/>}</>}
					</div>
				</section>
			</main>

		</ListGroup.Item>
	)
}

OrderRow.propTypes = {
	order      : PropTypes.instanceOf(Order).isRequired,
	showStatus : PropTypes.bool,
	noHighlight: PropTypes.bool,
}
